var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.971 16.971"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "rotate(45 12.778 6.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_22",
    d: "M22 0H0",
    className: "cls-1",
    "data-name": "Line 22",
    transform: "translate(0 11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_23",
    d: "M22 0H0",
    className: "cls-1",
    "data-name": "Line 23",
    transform: "rotate(90 5.5 5.5)"
  }))));
}
export default __webpack_public_path__ + "static/media/ic_close.90f43f52.svg";
export { SvgIcClose as ReactComponent };